var Vue = require('vue');
var _ = require('lodash');
var toastr = require('toastr/toastr');
require('toastr/toastr.css');

var ImpressService = require('./services/ImpressService');
var VerticalService = require('./services/VerticalService');
var SelectService = require('./services/SystemsService');

var utils = require('./utils');

var DEMO_ORG_ADMIN_ID = '598b70095ac6710700eaf139';
var SEE_DEMO = 'seeDemo';

// Slides
var Intro = require('./components/intro/intro.js');
var Services = require('./components/services/services.js');
var DemoPreview = require('./components/demo-preview/demo-preview.js');
var Demo = require('./components/demo/demo.js');
var Testimonial = require('./components/testimonial/testimonial.js');
var Dashboard = require('./components/dashboard/dashboard.js');
var Challenges = require('./components/challenges/challenges.js');
var Solution = require('./components/solution/solution.js');
// Slides

var SignUpService = require('signup/SignUpService.js');
var URLHelper = require('utils/URLHelper.js');
var WOW = require('wow/dist/wow.js').WOW;
var TESTIMONIALS = require('./components/testimonial/testimonials.json');

var setup = JSON.parse(localStorage.setup || '{}') || {};
var orgName = location.pathname.slice(1);
var selectedVerticals = JSON.parse(localStorage['selectedVerticals-' + orgName] || 'false');

var url = _.get(setup, 'setup.website', 'https://www.tenfold.com');
var industry = _.get(setup, 'setup.industry', 'financial');
var testimonials = _.get(setup, 'setup.testimonials', []);

var floatingUiUrl = '/app/';
var windowWidth = Math.ceil(window.innerWidth * 1.2);
var preventReload = false;

function getBaseFontSize() {
    return Math.max(16, Math.ceil(window.innerWidth / 75)) + 'px';
}

function isFullScreen() {
    var scale = window.devicePixelRatio;
    var dx = Math.abs(window.innerWidth * scale - screen.width);
    var dy = Math.abs(window.innerHeight * scale - screen.height);
    if (!_.isUndefined('webkitIsFullScreen')) {
        return document.webkitIsFullScreen;
    }
    return dx < 5 && dy < 5;
}

function canFullScreen() {
    return !(isFullScreen() && !document.webkitIsFullScreen);
}

var user = JSON.parse(localStorage.guest || 'false');
var userDate = user && new Date(user.date);
var dateDateDiff = user && userDate.getTime() + 15 * 1000 * 60;
if (dateDateDiff < new Date() || user.orgName !== orgName) {
    user = false;
    localStorage.removeItem('guest');
}

const genericDemo = !!localStorage.getItem('guest');

Vue.config.devtools = true;
var app = new Vue({
    el: '#app',
    data: {
        editUrl: orgName ? '/form#' + orgName  : '/form',
        displaySimulateControls: false,
        company: '',
        customUrl: url,
        floatingUiUrl: floatingUiUrl,
        verticals: [],
        industry: industry,
        testimonials: testimonials,
        selectedVerticals: selectedVerticals || {},
        slides: getSlides(testimonials),
        presentingRole: 'Sales',
        showPreviewLogos: false,
        user: user,
        presentedBy: null,
        logoUrl: null,
        totalVerticals: 0,
        childrenReady: [],
        readyToLoad: false,
        guestSignup: {},
        isFullScreen: isFullScreen(),
        canFullScreen: canFullScreen(),
        baseFontSize: getBaseFontSize(),
        fullScreenText: /Macintosh/.test(navigator.userAgent) ? 'Ctrl+⌘+F to toggle fullscreen' : 'F11 to toggle fullscreen',
        windowWidth: windowWidth,
        orgName: null,
        notFound: false,
        isLoggedToDashboard: false,
        loggedIn: false,
        logoutURL: URLHelper.getLogout(),
        simulateCallData: {},
        useDesktopBackground: false
    },
    components: getComponents(),
    methods: {
        ready() {
            new WOW().init();
            app.$set(app, 'orgName', orgName);

            Promise.all([
                VerticalService.getAll(),
                SelectService.getAll()
            ]).then(result => {
                var verticals = result[0];
                var systems = result[1];

                verticals.forEach(v => {
                    var sys = systems.crms;

                    if (v.name === 'Phone Systems') {
                        sys = systems.phones;
                    } else if (_.includes(v.name, ['Chat Systems', 'Web Conference', 'Email'])) {
                        sys = systems.chats;
                    }

                    v.systems = _.difference(sys, v.options);
                    v.selectValues = [];
                });

                this.verticals = verticals;
                this.totalVerticals = _.size(verticals);
                this.updateSelectedVerticals();
            });

            SignUpService.getCurrentUser()
                .then((_user) => {
                    function handleUser(_user) {
                        var currentUser = user || {};
                        _user.guest = currentUser.guest;

                        if (!_user.isGuest) {
                            app.$set(app, 'loggedIn', !!_user);
                            app.$set(app, 'user', _user);
                        }

                        if (!orgName && !genericDemo) {
                            location.href = '/form';
                            return Promise.resolve();
                        }

                        this.onUserRetrieved();
                        return Promise.resolve();
                    }

                    if (!_user && !orgName) {
                        return Promise.resolve();
                    }

                    if (!_user && orgName) {
                        return this.loginToDashboard(DEMO_ORG_ADMIN_ID).then((user) => {
                            handleUser.call(this, user);
                        });
                    }

                    return handleUser.call(this, _user);

                })
                .then(() => {
                    let promise;
                    if (orgName) {
                        promise = SignUpService.findDemoByHandle(orgName)
                            .then((result) => result.demo)
                            .catch(console.log)
                            .then(this.fillOrg);
                    } else {
                        promise = Promise.resolve();
                    }
                    return promise;
                })
                .catch((err) => {
                    console.error(err);
                })
                .then(app.loadImpress);

            this.bindEvents();
        },
        loadImpress() {
            const hideSlides = ['challenges', 'solution'];
            const hasUser = _.get(this.user, '_id');
            // prevent loading impress if redirecting to /form
            if (hasUser && !orgName && !genericDemo) {
                return;
            }
            if (app.slides && hasUser && !genericDemo) {
                app.slides = app.slides.filter(s => !hideSlides.includes(s.is));
            }

            app.setup = app.setup || {};
            app.slides = app.slides || [];
            setTimeout(ImpressService.init);
        },
        fillOrg(demo) {
            if (orgName && !demo) {
                app.$set(app, 'notFound', true);
                app.$set(app, 'slides', getSlides(testimonials));
                location.hash = '#/404';
                return Promise.resolve();
            }

            var crmName = _.get(demo, 'crmAccount.name');
            var name = crmName || demo.company;

            app.setup = demo;
            app.$set(app, 'company', name);
            app.$set(app, 'customUrl', demo.website);
            app.$set(app, 'industry', demo.industry);
            app.$set(app, 'presentingRole', demo.presentingRole || 'Sales');
            app.$set(app, 'testimonials', demo.testimonials || []);
            app.$set(app, 'presentedBy', demo.presentedBy);
            app.$set(app, 'logoUrl', demo.logoUrl);
            app.$set(app, 'selectedVerticals', demo.selectedVerticals || app.selectedVerticals);
            app.$set(app, 'slides', getSlides(demo.testimonials || []));
            this.updateSelectedVerticals();
        },
        loginToDashboard(userId) {
            //const user = this.organization ? this.organization._admin : DEMO_ORG_ADMIN_ID;
            const url = URLHelper.getDashboardLoginWithToken();
            return new Promise((resolve, reject) => {
                $.ajax({
                    url: url,
                    method: 'POST',
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        token: userId,
                        api: "true"
                    },
                    crossDomain: true,
                    complete: () => {
                        this.onUserRetrieved();
                        SignUpService.getCurrentUser().then(resolve);
                    }
                });
            })
        },
        onUserRetrieved() {
            app.$set(app, 'isLoggedToDashboard', true);
        },
        toggleFullscreen() {
            var isFull = isFullScreen();
            var documentElement = document.documentElement;
            preventReload = !isFull;
            this.isFullScreen = !isFull;
            return isFull ? document.webkitExitFullscreen() : documentElement.webkitRequestFullScreen();
        },
        saveVerticals(selectedVerticals) {

        },
        bindEvents() {
            ImpressService.onEnter("demo-preview", (to, from) => {
                if (!from) {
                    app.delayedPost = !app.readyForSetup;
                }
                app.$set(app, 'showPreviewLogos', true);
            });

            ImpressService.onEnter("demo", (to, from, allSlides) => {
                this.displaySimulateControls = true;
            });

            ImpressService.onLeave("demo", () => {
                this.displaySimulateControls = false;
            });

            ImpressService.onLeave("demo-preview", (to, from, allSlides) => {
                app.$set(app, 'showPreviewLogos', false);
            });

            $('body').on('hidden.bs.select', '.selectpicker', function (e) {
                var $input = $('.selectpicker');
                var e = document.createEvent('HTMLEvents');
                e.initEvent('input', true, true);
                $input[0].dispatchEvent(e);
            });
        },
        postSelected() {
            var demo = utils.createDemoData(app);
            $('iframe[name^=demo]').each(function (i, iframe) {
                iframe.contentWindow.postMessage(demo, '*');
            });
        },
        onSubmit() {
            if (this.userChoice === SEE_DEMO) {
                this.seeDemo();
            } else {
                this.startPresentation();
            }
        },
        seeDemo() {
            if (this.user) {
                app.$set(app, 'user', _.merge(app.user, { guest: {} }));
            } else {
                this.startPresentation();
            }
        },
        startPresentation() {
            if (app.isSaving) {
                return;
            }
            app.isSaving = true;
            SignUpService
                .createGuest(app.guestSignup, app.orgName, app.user)
                .then((guest) => {
                    app.$set(app, 'user', { guest: guest });
                    app.user.date = new Date();
                    app.user.orgName = app.orgName;
                    localStorage.setItem('guest', JSON.stringify(app.user));
                    toastr.success('Demo ready');
                    app.isSaving = false;
                })
                .then(this.loginToDashboard.bind(this, DEMO_ORG_ADMIN_ID))
                .catch(err => {
                    app.$set(app, 'user', { guest: {} });
                    console.error("Could not create a guest, check your config", err.responseText);
                    toastr.success('Demo ready');
                    app.isSaving = false;
                });

            toastr.info('Preparing your demo environment...');
        },
        updateSelectedVerticals() {
            this.verticals.forEach(v => {
                v.selectValues = _.intersection(v.systems, this.selectedVerticals[v.name]);
            });
        },
        setUserChoice(choice) {
            this.userChoice = choice;
        },
        goToNextSlide() {
            ImpressService.next();
        },
        goToPreviousSlide() {
            ImpressService.prev();
        },
        simulate(type, matchType) {
            this.$set(app, 'simulateCallData', {
                direction: type,
                matchType: matchType
            });
        },
        onSelectedVerticalsChanged(selectedVerticals) {
            let promise = Promise.resolve();
            selectedVerticals = selectedVerticals || app.setup.selectedVerticals;
            localStorage.setItem(`selectedVerticals-${orgName}`, JSON.stringify(selectedVerticals));

            if (app.user && app.setup) {
                app.setup.selectedVerticals = selectedVerticals;
                var updates = {
                    setup: app.setup,
                    slides: app.customSlides
                };
                promise = SignUpService.updateDemo(orgName, app.setup)
                    .then((result) => {
                        const { demo } = result;
                        _.assign(setup, demo || {});
                        localStorage.setItem("setup", JSON.stringify(setup));
                    });
            }

            return promise;
        },
        toggleBackground() {
            this.useDesktopBackground = !this.useDesktopBackground;
        }
    },
});

app.ready();

function getSlides(testimonials) {
    var testimonialComponents = testimonials
        .filter(_.isString)
        .map(t => ({ is: t }));
    var defaultSlides = [
        { is: 'intro' },
        { is: 'services' },
        { is: 'challenges' },
        { is: 'solution' },
        { is: 'demo-preview' },
        { is: 'demo' }
    ].concat(testimonialComponents).concat([
        { is: 'dashboard' }
    ]);

    if (app && app.notFound) {
        defaultSlides.unshift({ is: '404' });
    }

    return defaultSlides;
}

function getComponents() {
    var components = {
        '404': { template: '<div id="404" class="step slide" data-x="0" data-y="0"></div>' },
        'intro': Intro,
        'services': Services,
        'challenges': Challenges,
        'solution': Solution,
        'demo-preview': DemoPreview,
        'demo': Demo,
        'dashboard': Dashboard
    };

    _.each(TESTIMONIALS, t => components[t.id] = Testimonial(t));

    return components;
}

window.addEventListener('message', function (event) {
    if (event.data && event.data.READY_FOR_SETUP) {

        app.postSelected();

        var tags = ['A', 'INPUT', 'TEXTAREA', 'BUTTON', 'MD-SELECT'];
        if (event.source && event.source.document) {
            event.source.document.onkeydown = function (event) {
                var isInput = _.includes(tags, event.target.tagName);
                var action = getKeyActions()[event.keyCode] || _.noop;
                !isInput && action();
            };
        }

        if (event.data.name === 'demo-badge') {
            var iframe = document.querySelector("iframe[name='demo-badge']");
            var dragging = false;
            var startY = 0;
            var startPageY = 0;

            iframe.style.top = (window.innerHeight - 200) + 'px';

            if (event.source && event.source.document) {
                event.source.document.addEventListener('mousedown', event => {
                    if (event.target.hasAttribute('md-virtual-repeat')) {
                        return;
                    }

                    dragging = true;
                    document.getElementById('badge').classList.add('dragging');
                    startY = parseInt(iframe.style.top) || 0;
                    startPageY = event.pageY + startY;
                    event.preventDefault();
                });
            }

            document.addEventListener('mousemove', event => {
                if (event.target.hasAttribute('md-virtual-repeat')) {
                    return;
                }

                if (dragging) {
                    var dy = event.pageY - startPageY;
                    var top = _.clamp(startY + dy, 0, window.innerHeight - 200);
                    iframe.style.top = top + 'px';
                    event.preventDefault();
                }
            });

            document.addEventListener('mouseup', event => {
                if (event.target.hasAttribute('md-virtual-repeat')) {
                    return;
                }

                dragging = false;
                document.getElementById('badge').classList.remove('dragging');
                event.preventDefault();
            });

            window.addEventListener('resize', () => {
                var top = parseInt(iframe.style.top) || 0;
                iframe.style.top = _.clamp(top, 0, window.innerHeight - 200) + 'px';
            });
        }
    }
});

function resizeHandler() {
    if (window.innerWidth > windowWidth) {
        windowWidth = window.innerWidth;
        app.$set(app, 'windowWidth', windowWidth);
        app.$nextTick(() => {
            ImpressService.resetSteps();
        });
        if (!preventReload) {
            location.reload();
        }
    } else {
        app.$set(app, 'baseFontSize', getBaseFontSize());
    }

    app.$set(app, 'isFullScreen', isFullScreen());
    app.$set(app, 'canFullScreen', canFullScreen());
}
window.addEventListener('resize', resizeHandler);
window.addEventListener('webkitfullscreenchange', resizeHandler);

window.addEventListener('keyup', function (event) {
    if (event.shiftKey || event.altKey || event.ctrlKey || event.metaKey) {
        return;
    }

    var action = getKeyActions()[event.keyCode];

    if (action && app.user) {
        action();
        event.preventDefault();
    }
});

window.addEventListener('beforeunload', function () {
    if (app.user && (app.orgName || app.user.guest)) {
        SignUpService.unload(app.user, app.orgName);
    }
}, false);

// prevent impress from eating [tab] key when filling-in user form
const userForm = document.getElementById('user-form');
if (userForm) {
    userForm.addEventListener('keydown', event => event.stopPropagation());
    userForm.addEventListener('keyup', event => event.stopPropagation());
}

function getKeyActions() {
    return {
        32: ImpressService.next,
        37: ImpressService.prev,
        39: ImpressService.next,
        38: ImpressService.start,
        40: ImpressService.end
    };
}



//////////////////
// WEBPACK FOOTER
// ./src/js/app.js
// module id = 38
// module chunks = 0